import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home.component';
import { FeaturesComponent } from './features.component';
import { PricingComponent } from './pricing.component';
import { GuideComponent } from './guide.component';
import { ContactComponent } from './contact/contact.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { DashEnterpriseAuthComponent } from './dash-enterprise-auth/dash-enterprise-auth.component';
import { GuideEnterpriseComponent } from './guide-enterprise/guide-enterprise.component';
import { GuideEnterpriseDashboardComponent } from './guide-enterprise-dashboard/guide-enterprise-dashboard.component';
import { GuideEnterpriseMdmComponent } from './guide-enterprise-mdm/guide-enterprise-mdm.component';
import { GuideEnterpriseDashboardConfigurationComponent } from './guide-enterprise-dashboard-configuration/guide-enterprise-dashboard-configuration.component';
import { EnterpriseConfigurationValuesComponent } from './enterprise-configuration-values/enterprise-configuration-values.component';
import { DataDeletionComponent } from './data-deletion/data-deletion.component';
import { GuideEnterpriseUserAdministrationComponent } from './guide-enterprise-user-administration/guide-enterprise-user-administration.component';
import { HardwareComponent } from './hardware/hardware.component';
import { GuideEnterpriseWebComponent } from './guide-enterprise-web/guide-enterprise-web.component';

import { TestGuardGuard } from './test-guard.guard';



const routes: Routes = [
  {
      path: 'privacy-policy',
      component: PrivacyPolicyComponent,
      data: { title: 'Privacy Policy - ' }
  },
  {
      path: 'terms-of-service',
      component: TermsOfServiceComponent,
      data: { title: 'Terms of Service - ' }
  },
  {
      path: 'hardware',
      component: HardwareComponent,
      data: { title: 'Hardware - ' }
  },
  {
      path: 'enterprise',
      component: GuideEnterpriseComponent,
      data: { title: 'Dash Enterprise - ' }
  },
  {
      path: 'enterprise/dashboard',
      component: GuideEnterpriseDashboardComponent,
      data: { title: 'Dash Enterprise - Web Dashboard' }
  },
  {
      path: 'enterprise/dashboard-configuration',
      component: GuideEnterpriseDashboardConfigurationComponent,
      data: { title: 'Dash Enterprise - Configuring Dash' }
  },
  {
      path: 'enterprise/web-app',
      component: GuideEnterpriseWebComponent,
      data: { title: 'Dash Enterprise - Dash web app' }
  },
  {
      path: 'enterprise/configuration-options',
      component: EnterpriseConfigurationValuesComponent,
      data: { title: 'Dash Enterprise - Configuration options' }
  },
  {
      path: 'enterprise/user-administration',
      component: GuideEnterpriseUserAdministrationComponent,
      data: { title: 'Dash Enterprise - User administration' }
  },
  {
      path: 'enterprise/mdm',
      component: GuideEnterpriseMdmComponent,
      data: { title: 'Dash Enterprise - MDM' }
  },
  {
      path: 'guide/:id',
      component: GuideComponent,
      canActivate: [TestGuardGuard],
      data: { title: 'Guide - ' }
  },
  {
      path: 'guide',
      component: GuideComponent,
      data: { title: 'Guide - ' }
  },
  {
      path: 'contact',
      component: ContactComponent,
      data: { title: 'Contact - ' }
  },
  {
    path: 'features',
    component: FeaturesComponent,
    data: { title: 'Features - ' }
  },
  {
      path: 'pricing',
      component: PricingComponent,
      data: { title: 'Pricing - ' }
  },
  { path: 'home',
    component: HomeComponent,
    data: { title: '' }
  },
  {
      path: 'dash-enterprise-auth',
      component: DashEnterpriseAuthComponent,
      data: { title: '' }
  },
  {
      path: 'data-deletion',
      component: DataDeletionComponent,
      data: { title: '' }
  },
  { path: '',
      redirectTo: '/home',
      pathMatch: 'full'
  },
  { path: '**',
      redirectTo: '/home',
      pathMatch: 'full'
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled',
    scrollOffset: [0, window.innerWidth < 800 ? 150 : window.innerHeight / 2 - 125],
    scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
